import vars from "../vars";

$(document).ready(function() {
	var inputSearch = vars.$crossBtnSearch.prev();
	var inputContent = vars.$crossBtnContent.prev();
	var val = "";

	$(inputSearch).bind('input', function() { 
		val = $(this).val();

		if (val == '') {
			vars.$crossBtnSearch.addClass("hide");
		} else {
			vars.$crossBtnSearch.removeClass("hide");
		}
	});

	$(inputContent).bind('input', function() { 
		val = $(this).val();

		if (val == '') {
			vars.$crossBtnContent.addClass("hide");
		} else {
			vars.$crossBtnContent.removeClass("hide");
		}
	});

	vars.$crossBtnSearch.click(function() {
		$(inputSearch).val('');
		$(this).addClass("hide");
	});

	vars.$crossBtnContent.click(function() {
		$(inputContent).val('');
		$(this).addClass("hide");
	});
});


// WEBPACK FOOTER //
// ./src/js/general/search-clear.js